import React from 'react'
import { NavLink } from 'react-router-dom'

const PaymentSuccess = () => {
    return (
        <div>
            <div className="container py-5 my-5">
                <div className="row">
                    
                    <div className="col-md-6">
                        <h1 className="text-primary fw-bold mb-4 my-5">Order Successful! Please Wait For Your Order Patiently.</h1>
                        <p className="lead mb-4">
                            If your order took longer than expected, feel free to Contact Us!
                            <NavLink to="/contact" className="btn btn-outline-primary my-3 px-3">Contact Us</NavLink>

                        </p>
                    </div>
                    <div className="col-md-4 d-flex justify-content-center">
                    <img src="/assets/images/bg/sc.gif" alt="Payment Successful" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PaymentSuccess
